import { i18n } from 'src/i18n';
import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import workflowLaunchEnumerators from 'src/modules/workflowLaunch/workflowLaunchEnumerators';

export default [
  {
    name: 'name',
    label: i18n('entities.workflowLaunch.fields.name'),
    schema: schemas.string(
      i18n('entities.workflowLaunch.fields.name'),
      { required: true },
    ),
  },
  {
    name: 'description',
    label: i18n(
      'entities.workflowLaunch.fields.description',
    ),
    schema: schemas.string(
      i18n('entities.workflowLaunch.fields.description'),
      {},
    ),
  },
  {
    name: 'status',
    label: i18n('entities.workflowLaunch.fields.status'),
    schema: schemas.enumerator(
      i18n('entities.workflowLaunch.fields.status'),
      {
        options: workflowLaunchEnumerators.status,
      },
    ),
  },
  {
    name: 'scheduledAt',
    label: i18n(
      'entities.workflowLaunch.fields.scheduledAt',
    ),
    schema: schemas.datetime(
      i18n('entities.workflowLaunch.fields.scheduledAt'),
      {},
    ),
  },
  {
    name: 'workflow',
    label: i18n('entities.workflowLaunch.fields.workflow'),
    schema: schemas.relationToOne(
      i18n('entities.workflowLaunch.fields.workflow'),
      {},
    ),
  },
  {
    name: 'appUsers',
    label: i18n('entities.workflowLaunch.fields.appUsers'),
    schema: schemas.relationToMany(
      i18n('entities.workflowLaunch.fields.appUsers'),
      {},
    ),
  },
  {
    name: 'recipients',
    label: i18n(
      'entities.workflowLaunch.fields.recipients',
    ),
    schema: schemas.relationToMany(
      i18n('entities.workflowLaunch.fields.recipients'),
      {},
    ),
  },
  {
    name: 'locations',
    label: i18n('entities.workflowLaunch.fields.locations'),
    schema: schemas.relationToMany(
      i18n('entities.workflowLaunch.fields.locations'),
      {},
    ),
  },
  {
    name: 'assets',
    label: i18n('entities.workflowLaunch.fields.assets'),
    schema: schemas.relationToMany(
      i18n('entities.workflowLaunch.fields.assets'),
      {},
    ),
  },
];
